import { FC } from 'react'

const BelgianFlagSmall: FC = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47223_1366058"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="15"
      height="16"
    >
      <circle
        cx="7.5"
        cy="8"
        r="7.5"
        transform="rotate(-90 7.5 8)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_47223_1366058)">
      <g filter="url(#filter0_dd_47223_1366058)">
        <path
          d="M1 18.5C0.447715 18.5 5.33895e-09 18.0523 1.19249e-08 17.5L2.26573e-07 -0.5C2.33159e-07 -1.05228 0.447716 -1.5 1 -1.5L5 -1.5L5 18.5L1 18.5Z"
          fill="black"
        />
        <rect
          x="5"
          y="18.5"
          width="20"
          height="5"
          transform="rotate(-90 5 18.5)"
          fill="#F7DB52"
        />
        <path
          d="M10 18.5L10 -1.5L14 -1.5C14.5523 -1.5 15 -1.05228 15 -0.5L15 17.5C15 18.0523 14.5523 18.5 14 18.5L10 18.5Z"
          fill="#B12A33"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_47223_1366058"
        x="-10"
        y="-11.5"
        width="35"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_47223_1366058"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_47223_1366058"
          result="effect2_dropShadow_47223_1366058"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_47223_1366058"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default BelgianFlagSmall
